import { BaseSyntheticEvent, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { userNameValidation } from "../../../common/Valitation";
import { OnsiteTextField } from "../../../customelements/CustomInput";
import { HttpPostData, JumpPage } from "../../../common/Util";
import { MessageParam } from "../../Message";
import { LoginStateConext } from "../../../context/AuthContext";
import { ResponseParamBase } from "../../../common/Types";
import { TitleParamContext } from "../../../context/TitleContext";
import market from "../../../css/market.module.scss";
import base from "../../../css/base.module.css";


//パスワード変更画面

export interface IFormInputs {
    userName: string
}

export type ResponseParam = ResponseParamBase & {
    newusername: string
}

const schema = Yup.object({
    userName: userNameValidation
}).required();

export const ChangeUserName = () => {

    const userProvider = useContext(LoginStateConext);
    const titleContext = useContext(TitleParamContext);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");

    const { register, handleSubmit, control, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            userName: userProvider.loginInfo.userName,
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

   

    useEffect(() => {
        titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "利用者名変更", secondSubTitle: "" });
    }, [])

    const onSubmit: SubmitHandler<IFormInputs> = (data: IFormInputs, event?: BaseSyntheticEvent) => {
        setMessage("");
        HttpPostData<ResponseParam>("/UserManager/changeusername", { username: userProvider.loginInfo.userName, email: userProvider.loginInfo.email, newusername: data.userName }, setIsLoading)
            .then(response => {
                if (response.data.resultFlg) {
                    const responsedata = response.data;
                    userProvider.setLoginInfo({ ...userProvider.loginInfo, userName: responsedata.newusername });
                    JumpPage<MessageParam>("Message", { message: "利用者名を変更しました。", displayButton: true }, "", navigate);
                } else {
                    setMessage(response.data.message);
                }
            })
            .catch(e => {
                
            })
    }
    return (
        <>
      
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>
                    <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputLongTitle}>
                                <h3>利用者（会社名または個人名）</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="userName"
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                            <OnsiteTextField
                                                {...field}
                                                {...register("userName")}
                                                error={errors.userName ? true : false}
                                                helperText={errors.userName?.message}
                                                margin="normal"
                                                fullWidth={true}
                                            />
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className={market.marketFooterArea}>
                            <button className={market.marketBackButton} type="button" onClick={(e) => { JumpPage("/MyPage", {}, "", navigate); }}>戻る</button>
                            <button className={market.marketButton} type="submit" disabled={!isValid || isLoading}>登録</button>
                            <button style={{ visibility: "hidden" }} className="marketBackButton">＜　進む</button>
                        </div>
                        <div className={base.errorMessage}>{message}</div>
                    </form>
                    </div>
            </section>

           
        </>

    );
}